import {useEffect, useState} from "react";
import {WebGLState} from "../types/Types";


export function useWebGL() {
  const [state, setState] = useState<WebGLState>({
    supported: false,
    version: null,
    renderer: null,
    checked: false,
  });

  useEffect(() => {
    const canvas = document.createElement("canvas");

    let version: "webgl2" | "webgl" | null = null;

    // Try WebGL2 first
    let gl: RenderingContext | null = canvas.getContext("webgl2");
    if (gl) {
      version = "webgl2";
    } else {
      gl =
        canvas.getContext("webgl") ||
        canvas.getContext("experimental-webgl");
      if (gl) version = "webgl";
    }

    let renderer = null;
    if (gl && gl instanceof WebGLRenderingContext) {
      const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
      if (debugInfo) {
        renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }

    setState({
      supported: !!gl,
      version,
      renderer,
      checked: true,
    });
  }, []);

  return state;
}
